import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

type SessionStore = {
  utmParams: UtmParams | null;
  setUtmParams: (params: UtmParams) => void;
  clearUtmParams: () => void;
};

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      utmParams: null,
      setUtmParams: (params) => set({ utmParams: params }),
      clearUtmParams: () => set({ utmParams: null }),
    }),
    {
      name: 'gamma-prime-session',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const getStoredUtmParams = (): UtmParams | null => {
  return useSessionStore.getState().utmParams;
};

export const storeUtmParams = (params: UtmParams): void => {
  if (Object.keys(params).length > 0) {
    useSessionStore.getState().setUtmParams(params);
    console.log('[SessionStore] Stored UTM params:', params);
  }
};

export const clearStoredUtmParams = (): void => {
  useSessionStore.getState().clearUtmParams();
  console.log('[SessionStore] Cleared UTM params');
};

export const retrieveAndClearUtmParams = (): UtmParams | null => {
  const params = getStoredUtmParams();
  clearStoredUtmParams();
  return params;
};
